/**
 * Static-translations for pl. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const pl = {
  'anon.heading_default': 'Kontynuuj jako gość',
  'anon.try_again': 'Spróbuj ponownie',
  'auth.back_to_login': 'Powrót do logowania',
  'auth.check_email_message': 'Sprawdź skrzynkę — wysłaliśmy kod potwierdzający.',
  'auth.check_email_title': 'Sprawdź pocztę',
  'auth.confirm_email_title': 'Potwierdź e-mail',
  'auth.confirmation_code': 'Kod potwierdzający',
  'auth.continue_with_apple': 'Kontynuuj przez Apple',
  'auth.continue_with_facebook': 'Kontynuuj z Facebookiem',
  'auth.continue_with_github': 'Kontynuuj z GitHub',
  'auth.continue_with_google': 'Kontynuuj przez Google',
  'auth.create_account': 'Utwórz konto',
  'auth.default_subtitle': 'Zaloguj się, aby uzyskać dostęp do wszystkich funkcji i zsynchronizować dane.',
  'auth.email': 'Adres e-mail',
  'auth.email_already_registered': 'Ten e-mail jest już zarejestrowany. Zaloguj się poniżej hasłem lub kontem użytym przy rejestracji.',
  'auth.email_exists': 'Konto z tym adresem e-mail już istnieje.',
  'auth.email_not_confirmed': 'Najpierw potwierdź swój e-mail.',
  'auth.forgot_password': 'Nie pamiętasz hasła?',
  'auth.forgot_password_title': 'Nie pamiętasz hasła?',
  'auth.forgot_subtitle': 'Podaj swój adres e-mail, a wyślemy Ci link do resetowania hasła.',
  'auth.generic_error': 'Coś poszło nie tak',
  'auth.have_account': 'Masz konto?',
  'auth.hide_password': 'Ukryj hasło',
  'auth.identity_already_linked': 'To konto jest już zarejestrowane. Zaloguj się nim poniżej.',
  'auth.invalid_credentials': 'Nieprawidłowy e-mail lub hasło',
  'auth.invalid_otp': 'Kod jest nieprawidłowy lub wygasł.',
  'auth.last_used': 'Ostatnio użyte · {email}',
  'auth.last_used_no_email': 'Ostatnio użyte',
  'auth.link_purchase_subheading': 'Powiążemy zakup z Twoim kontem, aby zachować dostęp.',
  'auth.log_in': 'Zaloguj się',
  'auth.log_in_link': 'Zaloguj się',
  'auth.login_continue_purchase': 'Zaloguj się, aby kontynuować zakup',
  'auth.network_error': 'Błąd sieci. Sprawdź połączenie i spróbuj ponownie.',
  'auth.no_account': 'Nie masz konta?',
  'auth.or': 'lub',
  'auth.password': 'Hasło',
  'auth.passwords_mismatch': 'Hasła nie pasują do siebie',
  'auth.rate_limited': 'Zbyt wiele żądań. Spróbuj ponownie później.',
  'auth.repeat_password': 'Powtórz hasło',
  'auth.reset_link_valid': 'Link jest ważny przez 1 godzinę.',
  'auth.reset_password_title': 'Zresetuj hasło',
  'auth.reset_sent_message': 'Jeśli ten adres istnieje, wysłaliśmy kod resetujący.',
  'auth.reset_sent_subtitle': 'Wysłaliśmy link do resetowania hasła. Postępuj zgodnie z instrukcjami w wiadomości.',
  'auth.restore_purchases_heading': 'Przywróć zakupy',
  'auth.restore_purchases_subheading': 'Zaloguj się, aby przywrócić swoje zakupy.',
  'auth.send_reset': 'Wyślij link resetujący',
  'auth.service_unavailable': 'Usługa chwilowo niedostępna. Spróbuj później.',
  'auth.show_password': 'Pokaż hasło',
  'auth.sign_out': 'Wyloguj',
  'auth.sign_up': 'Zarejestruj się',
  'auth.sign_up_link': 'Zarejestruj się',
  'auth.signed_in': 'Zalogowano',
  'auth.signin_failed': 'Logowanie nie powiodło się',
  'auth.signup_failed': 'Rejestracja nie powiodła się',
  'auth.verify': 'Zweryfikuj',
  'auth.weak_password': 'Hasło jest zbyt słabe.',
  'auth.welcome': 'Witaj!',
  'auth.welcome_signup': 'Witamy!',
  'cta.close': 'Zamknij',
  'cta.continue': 'Kontynuuj',
  'cta.get_lifetime_access': 'Uzyskaj dożywotni dostęp',
  'cta.get_plan_daily': 'Wybierz plan dzienny',
  'cta.get_plan_monthly': 'Wybierz plan miesięczny',
  'cta.get_plan_weekly': 'Wybierz plan tygodniowy',
  'cta.get_plan_yearly': 'Wybierz plan roczny',
  'cta.start_trial': 'Rozpocznij {days}-dniowy darmowy okres próbny',
  'modal.close_aria': 'Zamknij',
  'modal.continue': 'Kontynuuj',
  'modal.error_generic': 'Coś poszło nie tak',
  'modal.loading': 'Ładowanie…',
  'modal.purchase_restored_subtitle': 'Wszystko gotowe — korzystaj!',
  'modal.purchase_restored_title': 'Witamy ponownie',
  'modal.purchase_success_subtitle': 'Wszystko gotowe — korzystaj!',
  'modal.purchase_success_title': 'Płatność otrzymana',
  'modal.verifying_subscription': 'Sprawdzanie subskrypcji…',
  'nav.back': '← Wstecz',
  'nav.back_aria': 'Wstecz',
  'offer.limited_time': 'Oferta ograniczona czasowo',
  'payment.awaiting_title': 'Dokończ płatność w nowej karcie',
  'payment.checking': 'Sprawdzanie…',
  'payment.ive_paid': 'Zapłaciłem',
  'payment.open_checkout_again': 'Otwórz płatność ponownie',
  'payment.open_checkout_button': 'Otwórz płatność',
  'pricing.free_trial_days': '{days}-dniowa bezpłatna wersja próbna',
  'pricing.included_per': 'Wliczone w {interval}:',
  'pricing.interval.day': 'dzień',
  'pricing.interval.lifetime_short': 'dożywotnio',
  'pricing.interval.month': 'miesiąc',
  'pricing.interval.period': 'okres',
  'pricing.interval.week': 'tydzień',
  'pricing.interval.year': 'rok',
  'pricing.money_back': '30-dniowa gwarancja zwrotu pieniędzy',
  'pricing.most_popular': 'Najpopularniejszy',
  'pricing.no_prices': 'Brak dostępnych cen.',
  'pricing.plan_label.daily': 'PLAN DZIENNY',
  'pricing.plan_label.lifetime': 'dożywotni',
  'pricing.plan_label.monthly': 'plan miesięczny',
  'pricing.plan_label.weekly': 'plan tygodniowy',
  'pricing.plan_label.yearly': 'plan roczny',
  'pricing.plans_aria': 'Plany',
  'session.contact_support': 'Kontakt z pomocą',
  'session.restore_purchases': 'Przywróć zakupy',
  'session.sign_out': 'Wyloguj',
  'session.signed_in_as_prefix': 'Zalogowany jako',
  'session.signing_out': 'Wylogowywanie…',
  'support.attachments_label': 'Załączniki',
  'support.close_button': 'Zamknij',
  'support.done_button': 'Gotowe',
  'support.email_placeholder': 'Wprowadź swój e-mail',
  'support.heading': 'Wsparcie',
  'support.instruction': 'Wypełnij poniższy formularz, aby wysłać zgłoszenie do pomocy technicznej.',
  'support.invalid_email': 'Nieprawidłowy adres e-mail',
  'support.message_length': '1–5000 znaków',
  'support.message_placeholder': 'Wprowadź wiadomość',
  'support.required': 'Wymagane',
  'support.send_another': 'Wyślij kolejne zgłoszenie',
  'support.send_button': 'Wyślij',
  'support.sending': 'Wysyłanie…',
  'support.subject_length': '3–200 znaków',
  'support.subject_placeholder': 'Wprowadź temat',
  'support.success_heading': 'Zgłoszenie wysłane',
  'support.success_message_prefix': 'Otrzymaliśmy Twoją wiadomość i odpowiemy na adres'
} as const;

export default pl;
